var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187.48mm",
    height: "107.35mm",
    viewBox: "0 0 187.48 107.35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4702"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4712"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4722"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4732"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4742"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4752"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4762"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.8311e-4 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4772"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.8311e-4 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4786"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4796"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4806"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m457.5 251.25h133.5v132.75h-133.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4816"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4828"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4838"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4848"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4858"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-617.61 -425.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 558.65 571.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277.56 223.29c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.56 223.29c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.06 150.16h16.5v45h-16.5z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.06 150.16h16.5v45h-16.5z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.81 150.16h17.25v45h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.81 150.16h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.81 233.79c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.81 233.79c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.31 233.79c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.31 233.79c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.56 223.29c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.56 223.29c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.06 150.16h17.25v45h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.06 150.16h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.81 150.16h17.25v45h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.81 150.16h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.56 233.79c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.56 233.79c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.31 233.79c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.31 233.79c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m333.07 231.63c0-1.08-0.88-1.95-1.95-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.95 1.95 1.95 1.07 0 1.95-0.88 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.27 231.82c0-1.07-0.88-1.94-1.95-1.94-1.08 0-1.95 0.87-1.95 1.94 0 1.08 0.87 1.95 1.95 1.95 1.07 0 1.95-0.87 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.92 230.92c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95c0 1.07 0.87 1.95 1.95 1.95s1.95-0.88 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m531.35 230.92c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95c0 1.07 0.87 1.95 1.95 1.95s1.95-0.88 1.95-1.95z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m300.06 267.16 25.5 49.5 25.5-49.5z",
    fill: "#4472c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.06 267.16 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m360.02 214.71-13.54-4.08c-7.48-2.25-14.65-0.4-16.02 4.15s3.58 10.06 11.06 12.31l13.54 4.08z",
    fill: "#000000",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m360.02 214.71-13.54-4.08c-7.48-2.25-14.65-0.4-16.02 4.15s3.58 10.06 11.06 12.31l13.54 4.08z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m442.57 220.06 12.57-6.47c6.94-3.58 10.81-9.9 8.63-14.13-2.17-4.22-9.57-4.74-16.51-1.16l-12.57 6.48z",
    fill: "#000000",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m442.57 220.06 12.57-6.47c6.94-3.58 10.81-9.9 8.63-14.13-2.17-4.22-9.57-4.74-16.51-1.16l-12.57 6.48z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m552.12 198.82-11.35-8.44c-6.26-4.66-13.64-5.35-16.48-1.54-2.83 3.82-0.04 10.68 6.23 15.34l11.35 8.44z",
    fill: "#000000",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m552.12 198.82-11.35-8.44c-6.26-4.66-13.64-5.35-16.48-1.54-2.83 3.82-0.04 10.68 6.23 15.34l11.35 8.44z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m634.15 214.46 12.4-6.8c6.85-3.76 10.54-10.18 8.26-14.35-2.28-4.16-9.69-4.49-16.54-0.73l-12.39 6.81z",
    fill: "#000000",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m634.15 214.46 12.4-6.8c6.85-3.76 10.54-10.18 8.26-14.35-2.28-4.16-9.69-4.49-16.54-0.73l-12.39 6.81z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m347.31 203.79c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.31 203.79c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m571.39 199.07c0.61 5.5 8.26 9.16 17.07 8.17s15.45-6.24 14.84-11.75l-4.98 0.56c0.31 2.75-4.36 5.53-10.42 6.21s-11.22-1-11.53-3.75z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m571.39 199.07c0.61 5.5 8.26 9.16 17.07 8.17s15.45-6.24 14.84-11.75l-4.98 0.56c0.31 2.75-4.36 5.53-10.42 6.21s-11.22-1-11.53-3.75z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4806)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8542,-3.77e-7,-7.54e-7,1.8437,457.5,251.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4816)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.891 51.366c-1.778-0.045-3.437-0.904-4.5-2.33-1.06 1.43-2.721 2.29-4.5 2.329-3.306-0.168-5.922-2.857-6-6.166 0-6.18 8.601-13.011 9.582-13.77l0.918-0.709 0.918 0.709c0.981 0.759 9.582 7.59 9.582 13.77-0.082 3.307-2.696 5.994-6 6.167zm-4.5-18.75s-9 6.961-9 12.583c0 2.283 2.1 4.666 4.5 4.666 1.459-0.071 2.794-0.846 3.578-2.08l-1.07-1.51 2.66-2.677-2.651-2.683 2.633-2.658c2e-3 -4e-3 6e-3 -5e-3 9e-3 -3e-3 4e-3 2e-3 5e-3 6e-3 3e-3 9e-3l-0.656 2.658 2.65 2.684-2.65 2.67c1.302 2.611 2.96 3.591 4.5 3.591 2.4 0 4.5-2.381 4.5-4.667-4e-3 -5.622-9.004-12.583-9.004-12.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.334 59.612h-45.9c-1.402-0.014-2.535-1.148-2.55-2.55v-30.984c-0.012-1.396 1.111-2.538 2.508-2.55h0.042 28.05l10.2-10.425v10.35h7.65c1.402 0.015 2.535 1.148 2.55 2.55v30.983c0.018 1.429-1.122 2.602-2.55 2.626zm1.05-33.609c-0.015-0.573-0.476-1.035-1.05-1.05h-9.15v-8.175l-7.626 7.798-0.441 0.45h-28.683c-0.567-0.013-1.037 0.437-1.05 1.004v0.046 30.985c0.015 0.574 0.476 1.035 1.05 1.05h45.9c0.6-0.022 1.069-0.525 1.05-1.125z"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m552.35 208.62c-0.49 3.44 2.15 6.66 5.88 7.19 2.25 0.32 4.5 0.63 6.76 0.95 0.29-2.08 0.59-4.16 0.88-6.23 0.49-3.45-2.15-6.67-5.88-7.2-3.73-0.52-7.15 1.84-7.64 5.29z",
    fill: "#4472c4",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m552.35 208.62c-0.49 3.44 2.15 6.66 5.88 7.19 2.25 0.32 4.5 0.63 6.76 0.95 0.29-2.08 0.59-4.16 0.88-6.23 0.49-3.45-2.15-6.67-5.88-7.2-3.73-0.52-7.15 1.84-7.64 5.29z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m620.95 206.28c-3.24 1.28-4.74 5.15-3.36 8.66 0.83 2.12 1.66 4.24 2.5 6.35 1.95-0.77 3.91-1.53 5.86-2.3 3.24-1.28 4.74-5.15 3.36-8.66s-5.12-5.32-8.36-4.05z",
    fill: "#4472c4",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.571 4.2857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m620.95 206.28c-3.24 1.28-4.74 5.15-3.36 8.66 0.83 2.12 1.66 4.24 2.5 6.35 1.95-0.77 3.91-1.53 5.86-2.3 3.24-1.28 4.74-5.15 3.36-8.66s-5.12-5.32-8.36-4.05z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m271.22 284.88c0-1.6 1.3-2.89 2.9-2.89s2.89 1.29 2.89 2.89-1.29 2.9-2.89 2.9-2.9-1.3-2.9-2.9z",
    fill: "#ffffff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.e3ff27211d53dbb9a30307442ee332f5.svg";
export { ForwardRef as ReactComponent };